<template>
  <ConditionsCard
    :patient-id="patientId"
    :info-title="infoTitle"
    category="chronic"
    :show-quick-add="showQuickAdd"
    icon="mdi-medical-bag"
    v-on="$listeners"
  />
</template>

<script>
import ConditionsCard from "@/features/patients/profile-dashboard/cards/ConditionsCard.vue";

export default {
  name: "ChronicDiseasesCard",
  components: { ConditionsCard },
  props: {
    patientId: { type: [String, Number], required: true },
    // O título vem de config/dashboardCards.js, via a página do dashboard.
    // Sem default de propósito: duplicar o texto aqui já fez a renomeação
    // do card passar despercebida uma vez.
    infoTitle: { type: String, required: true },
    // salvia-770: o card deixou de ser só-leitura. O "+" é repassado ao
    // ConditionsCard, e o registro entra já na categoria deste card — o médico
    // não escolhe, vê o campo preenchido e desabilitado.
    showQuickAdd: { type: Boolean, default: false },
  },
};
</script>
